import React, { useState } from 'react';
import { EnvelopeSimple, MapPin, Phone, WhatsappLogo } from '@phosphor-icons/react';
import { useI18n } from '../../i18n';
import SEO, { SEOConfigs } from '../common/SEO';

const Contact = () => {
  const { t } = useI18n();
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle');

  const handleChange = (event) => setFormData((current) => ({ ...current, [event.target.name]: event.target.value }));

  const handleSubmit = (event) => {
    event.preventDefault();
    setStatus('submitting');
    window.setTimeout(() => {
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 700);
  };

  const details = [
    { icon: EnvelopeSimple, label: 'Email', value: 'tafsirart@gmail.com', href: 'mailto:tafsirart@gmail.com' },
    { icon: Phone, label: 'Phone', value: '+27 64 130 4056', href: 'tel:+27641304056' },
    { icon: MapPin, label: 'Studio', value: 'Johannesburg' },
    { icon: WhatsappLogo, label: 'WhatsApp', value: '+27 64 130 4056', href: 'https://wa.me/27641304056' },
  ];

  return (
    <div className="tafsir-page">
      <SEO {...SEOConfigs.contact} />
      <div className="page-shell">
        <header className="max-w-5xl border-b border-border pb-10">
          <p className="editorial-eyebrow mb-4">{t('contact.eyebrow')}</p>
          <h1 className="editorial-title">{t('contact.title')}</h1>
          <p className="editorial-lede mt-5 max-w-2xl">{t('contact.intro')}</p>
        </header>

        <div className="grid gap-12 py-12 lg:grid-cols-[.72fr_1.28fr] lg:py-20">
          <aside>
            <h2 className="font-display text-4xl font-semibold">{t('contact.reach')}</h2>
            <p className="mt-3 max-w-md leading-7 text-text-secondary">{t('contact.response')}</p>
            <div className="mt-9 divide-y divide-border border-y border-border">
              {details.map(({ icon: Icon, label, value, href }) => (
                <div key={label} className="grid grid-cols-[42px_1fr] gap-4 py-5">
                  <span className="grid h-10 w-10 place-items-center rounded-full border border-border text-primary"><Icon size={19} /></span>
                  <div>
                    <span className="editorial-eyebrow block text-[10px]">{label}</span>
                    {href ? <a href={href} className="mt-1 block text-sm text-text-primary hover:text-primary">{value}</a> : <p className="mt-1 text-sm text-text-secondary">{value}</p>}
                  </div>
                </div>
              ))}
            </div>
          </aside>

          <section className="quiet-surface p-6 sm:p-9 lg:p-12">
            <h2 className="font-display text-4xl font-semibold">{t('contact.send')}</h2>
            {status === 'success' && <p role="status" className="mt-5 border-l-2 border-primary bg-background px-4 py-3 text-sm text-text-primary">{t('contact.success')}</p>}
            <form onSubmit={handleSubmit} className="mt-8 grid gap-5 sm:grid-cols-2">
              <label className="block">
                <span className="mb-2 block text-sm font-medium">{t('contact.name')}</span>
                <input required name="name" value={formData.name} onChange={handleChange} className="field" />
              </label>
              <label className="block">
                <span className="mb-2 block text-sm font-medium">{t('contact.email')}</span>
                <input required type="email" name="email" value={formData.email} onChange={handleChange} className="field" />
              </label>
              <label className="block sm:col-span-2">
                <span className="mb-2 block text-sm font-medium">{t('contact.subject')}</span>
                <input required name="subject" value={formData.subject} onChange={handleChange} className="field" />
              </label>
              <label className="block sm:col-span-2">
                <span className="mb-2 block text-sm font-medium">{t('contact.message')}</span>
                <textarea required rows="6" name="message" value={formData.message} onChange={handleChange} className="field resize-y" />
              </label>
              <button type="submit" disabled={status === 'submitting'} className="btn-primary sm:col-span-2 sm:w-max">
                {status === 'submitting' ? t('contact.sending') : t('contact.submit')}
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Contact;
